export const ausschreibungsdiensteSubmenuData = (windowWidth) =>
  windowWidth >= 1024
    ? [
        {
          type: "DropdownMenu",
          label: "Ausschreibungen",
          link: "/ausschreibungsdienste/ausschreibungen",
          page: "ausschreibungsdienste",
          dropdown_menu_items: [
            {
              type: "SubmenuLink",
              label: "Bauleistungen",
              link: "/ausschreibungsdienste/ausschreibungen/bauleistungen",
            },
            {
              type: "SubmenuLink",
              label: "Lieferleistungen",
              link: "/ausschreibungsdienste/ausschreibungen/lieferleistungen",
            },
            {
              type: "SubmenuLink",
              label: "Dienstleistungen",
              link: "/ausschreibungsdienste/ausschreibungen/dienstleistungen",
            },
            {
              type: "SubmenuLink",
              label: "Aufträge aus Ihrer Region",
              link: "/ausschreibungsdienste/ausschreibungen/region",
            },
          ],
        },
        {
          type: "SubmenuLink",
          label: "Pakete & Preise",
          link: "/ausschreibungsdienste/preise",
        },

        {
          type: "SubmenuLink",
          label: "Support",
          link: "/ausschreibungsdienste/support",
        },
        {
          type: "SubmenuLink",
          label: "An Vergabe teilnehmen",
          link: "/ausschreibungsdienste/teilnehmen",
        },
        {
          type: "CTAButton",
          label: "Kostenfrei testen",
          href: `${process.env.GATSBY_AD_SOFTWARE_PRODUCT_REGISTER_ADDRESS}${process.env.GATSBY_AD_SOFTWARE_PRODUCT_FREE_TEST_ID}`,
        },
      ]
    : [
        {
          type: "CTAButton",
          mobile: true,
          label: "Kostenfrei testen",
          href: `${process.env.GATSBY_AD_SOFTWARE_PRODUCT_REGISTER_ADDRESS}${process.env.GATSBY_AD_SOFTWARE_PRODUCT_FREE_TEST_ID}`,
        },
      ]
